// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { createRoot } from 'react-dom/client';
import App from './App';

const props = window.__INITIAL_DATA__;

createRoot(document.getElementById('app')).render(<App {...props} />);
